import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export function ClientePicker({ nome, onPick, testid = "cliente-picker" }) {
  const [q, setQ] = useState(nome || "");
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => { setQ(nome || ""); }, [nome]);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const search = async (v) => {
    setQ(v);
    onPick(null, v);
    if (v.trim().length >= 2) {
      try {
        const { data } = await api.get(`/anagrafiche?q=${encodeURIComponent(v)}&limit=8`);
        setRes(data); setOpen(true);
      } catch { setRes([]); }
    } else setOpen(false);
  };

  return (
    <div className="relative" ref={box}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input value={q} onChange={(e) => search(e.target.value)} placeholder="Cerca cliente in anagrafica…" className="pl-9" data-testid={testid} />
      {open && res.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-y-auto" data-testid={`${testid}-results`}>
          {res.map((r) => (
            <button key={r.id} type="button"
              onClick={() => { onPick(r.id, r.ragione_sociale); setQ(r.ragione_sociale); setOpen(false); }}
              className="block w-full text-left px-3 py-2 text-sm hover:bg-slate-100">
              <span className="font-medium text-slate-800">{r.ragione_sociale}</span>
              {r.partita_iva && <span className="text-xs text-slate-400"> · P.IVA {r.partita_iva}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
